import { gql } from '@apollo/client'

export const FETCH_DATA_EXPORT = gql`
  query dataExport {
    dataExport {
      success
    }
  }
`
